import { IChallengeList } from 'interfaces';

export const checkIfChallengeIsInChallengeList = (
  selectedChallengeId: any,
  sortedChallenges: IChallengeList[],
) =>
  !!sortedChallenges.find(
    (challenge: IChallengeList) => challenge.id === selectedChallengeId,
  );
